// extracted by mini-css-extract-plugin
module.exports = {"feed-bottom":"card-bottom_feed-bottom__0AyhO","feed-actions":"card-bottom_feed-actions__WNclD","action-item":"card-bottom_action-item__ApNEL"};